!function(){"use strict";const t="[data-image-id]",e="product-images",s="[data-section-id]",i="[data-thumb-item]",o="[data-thumb-link]",r="[data-thumbs-slider]",n="data-active-media",a="data-media-id",c="is-active";customElements.get("product-thumbs")||customElements.define("product-thumbs",class extends HTMLElement{constructor(){super(),this.container=this.closest(s),this.productImages=this.container.querySelectorAll(t),this.productImagesContainer=this.container.querySelector(e),this.productThumbs=this.container.querySelectorAll(i),this.thumbSlider=this.querySelector(r),this.thumbLinks=this.querySelectorAll(o)}connectedCallback(){this.handleEvents(),this.preloadImagesOnHover(),this.activeMediaObserver()}disconnectedCallback(){this.observer&&this.observer.disconnect()}activeMediaObserver(){this.observer=new MutationObserver((t=>{for(const e of t)"attributes"===e.type&&e.attributeName==n&&this.setActiveThumb()})),this.observer.observe(this.productImagesContainer,{attributes:!0,childList:!1,subtree:!1})}handleEvents(){this.thumbLinks?.forEach((t=>{t.addEventListener("click",(e=>{e.preventDefault();const s=t.closest(i),o=t.getAttribute(a);s.classList.contains(c)||this.dispatchEvent(new CustomEvent("theme:media:select",{bubbles:!0,detail:{id:o}}))})),t.addEventListener("keyup",(e=>{if("Enter"===e.code){const e=t.getAttribute(a),s=this.productImagesContainer.querySelector(`[${a}="${e}"]`)?.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];s&&(s.dispatchEvent(new Event("focus")),s.dispatchEvent(new Event("select")))}}))}))}preloadImagesOnHover(){this.thumbLinks?.forEach((t=>{t.addEventListener("mouseover",(()=>{const e=t.getAttribute(a);this.productImagesContainer.querySelector(`[${a}="${e}"] img`)?.setAttribute("loading","eager")}))}))}setActiveThumb(){const t=this.productImagesContainer.getAttribute(n),e=this.querySelector(`[${a}="${t}"]`);this.querySelector(`${i}.${c}`)?.classList.remove(c),e?.parentNode.classList.add(c),requestAnimationFrame((()=>{this.scrollToThumb()}))}scrollToThumb(){const t=this.thumbSlider;if(t){const e=t.querySelector(`.${c}`);if(!e)return;const s=t.scrollTop,i=t.scrollLeft,o=t.offsetWidth,r=t.offsetHeight,n=s+r,a=i+o,d=e.offsetTop,h=e.offsetLeft,l=e.offsetWidth,u=e.offsetHeight,m=s>d,b=i>h,v=h+l>a,f=d+u>n||m,p=v||b,g=window.theme.isMobile();if(f||p){let e=d-r+u,s=h-o+l;m&&(e=d),v&&g&&(s+=parseInt(window.getComputedStyle(t).paddingRight)),b&&(s=h,g&&(s-=parseInt(window.getComputedStyle(t).paddingLeft))),t.scrollTo({top:e,left:s,behavior:"smooth"})}}}})}();

document.querySelectorAll('[data-thumbs-track]').forEach(function (track) {
  var wrapper = track.closest('.product__thumbs');
  if (!wrapper) return;

  var holder = wrapper.querySelector('[data-thumbs-slider]');
  var handle = track.querySelector('[data-thumbs-handle]');
  if (!holder || !handle) return;

  function syncHandle() {
    var ratio = holder.clientWidth / holder.scrollWidth;
    if (ratio >= 1) {
      track.style.display = 'none';
      return;
    }
    track.style.display = '';
    var trackWidth = track.clientWidth;
    var handleWidth = Math.max(ratio * trackWidth, 24);
    var maxHandleLeft = trackWidth - handleWidth;
    var maxScrollLeft = holder.scrollWidth - holder.clientWidth;
    var handleLeft = maxScrollLeft > 0 ? (holder.scrollLeft / maxScrollLeft) * maxHandleLeft : 0;
    handle.style.width = handleWidth + 'px';
    handle.style.transform = 'translateX(' + handleLeft + 'px)';
  }

  holder.addEventListener('scroll', syncHandle);
  window.addEventListener('resize', syncHandle);
  syncHandle();

  var dragging = false;
  var startX = 0;
  var startHandleLeft = 0;

  function onPointerMove(e) {
    if (!dragging) return;
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var dx = clientX - startX;
    var trackWidth = track.clientWidth;
    var handleWidth = handle.offsetWidth;
    var maxHandleLeft = trackWidth - handleWidth;
    var newHandleLeft = Math.min(Math.max(startHandleLeft + dx, 0), maxHandleLeft);
    var maxScrollLeft = holder.scrollWidth - holder.clientWidth;
    holder.scrollLeft = maxHandleLeft > 0 ? (newHandleLeft / maxHandleLeft) * maxScrollLeft : 0;
    e.preventDefault();
  }

  function onPointerUp() {
    dragging = false;
    document.removeEventListener('mousemove', onPointerMove);
    document.removeEventListener('mouseup', onPointerUp);
    document.removeEventListener('touchmove', onPointerMove);
    document.removeEventListener('touchend', onPointerUp);
  }

  function onPointerDown(e) {
    dragging = true;
    startX = e.touches ? e.touches[0].clientX : e.clientX;
    startHandleLeft = handle.getBoundingClientRect().left - track.getBoundingClientRect().left;
    document.addEventListener('mousemove', onPointerMove);
    document.addEventListener('mouseup', onPointerUp);
    document.addEventListener('touchmove', onPointerMove, { passive: false });
    document.addEventListener('touchend', onPointerUp);
    e.preventDefault();
  }

  handle.addEventListener('dragstart', function (e) { e.preventDefault(); });
  handle.addEventListener('mousedown', onPointerDown);
  handle.addEventListener('touchstart', onPointerDown, { passive: false });

  track.addEventListener('click', function (e) {
    if (e.target === handle) return;
    var trackRect = track.getBoundingClientRect();
    var clickX = e.clientX - trackRect.left;
    var handleWidth = handle.offsetWidth;
    var maxHandleLeft = track.clientWidth - handleWidth;
    var newHandleLeft = Math.min(Math.max(clickX - handleWidth / 2, 0), maxHandleLeft);
    var maxScrollLeft = holder.scrollWidth - holder.clientWidth;
    holder.scrollLeft = maxHandleLeft > 0 ? (newHandleLeft / maxHandleLeft) * maxScrollLeft : 0;
  });
});
